import TitleInput from './inputs/title';
import BodyInput from './inputs/body';
import DescriptionInput from './inputs/description';
import './form.scss';

const UGCDraftFormFields = () => {
  return (
    <div className="post-form">
      <div className="content-submission-form__header">
        <div className="content-submission-form__text">
          <TitleInput />
          <DescriptionInput />
          <BodyInput />
        </div>
      </div>
    </div>
  );
};

export default UGCDraftFormFields;
